var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPictoWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "81px",
    height: "68px",
    viewBox: "0 0 81 68",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.6690482,2.10200577 C32.6134614,-2.57162563 37.3906642,-2.56628329 40.3317118,2.10200577 L70.0522918,49.2771216 C72.996705,53.950753 70.8972532,57.7394799 65.3787689,57.7394799 L4.62199111,57.7394799 C-0.903537566,57.7394799 -2.99257934,53.9454107 -0.0515318031,49.2771216 L29.6690482,2.10200577 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.267606431 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 69.1825985,
    height: 57,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1.-\\uB85C\\uADF8\\uC778,\\uD68C\\uC6D0\\uAC00\\uC785",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I4-1-404\\uD398\\uC774\\uC9C0",
    transform: "translate(-586.000000, -135.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(589.273438, 139.042969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Triangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#EF9C19",
    mask: "url(#mask-3)",
    strokeWidth: 2,
    fill: "#FFC200",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.9201575,18.2341687 C38.9201575,15.366829 37.1934214,13.9993286 34.9533315,13.9993286 C32.75991,13.9993286 31.0798425,15.1462645 31.0798425,18.1900558 C31.0798425,25.4245743 31.3131853,32.3503023 32.3865617,36.4969166 C32.9932527,38.8790141 33.7866179,40.2906275 35,40.2906275 C36.2133821,40.2906275 37.0534158,38.8790141 37.6601068,36.4969166 C38.6868147,32.3503023 38.9201575,25.3804613 38.9201575,18.2341687 Z M31.4531909,45.340032 C31.4531909,47.1486616 33.0399213,48.6485008 34.9533315,48.6485008 C36.8667416,48.6485008 38.453472,47.1486616 38.453472,45.340032 C38.453472,43.5314023 36.8667416,42.0315631 34.9533315,42.0315631 C33.0399213,42.0315631 31.4531909,43.5314023 31.4531909,45.340032 Z",
    id: "!",
    fill: "#000000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoWarning);
export default __webpack_public_path__ + "static/media/picto-warning.849f32898a038162a2a4efda9b6e7e02.svg";
export { ForwardRef as ReactComponent };